import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '../lib/utils.js';
export function Breadcrumb({ items, className }) {
    // Collapse adjacent crumbs that share a label (e.g. an org and a tenant named
    // the same → "retink.ai › retink.ai" reads like a bug). Drop the earlier of the
    // pair; the later one is where you are. The sidebar's parent back-button uses the
    // full trail, so the dropped level stays reachable.
    // ponytail: only de-dupes *adjacent* equal labels — the real-world case.
    const trail = items.filter((c, i) => c.label !== items[i + 1]?.label);
    return (_jsx("nav", { "aria-label": "Breadcrumb", className: cn('flex items-center gap-1.5 text-sm', className), children: trail.map((c, i) => {
            const last = i === trail.length - 1;
            const interactive = !last && (c.to || c.onClick);
            return (_jsxs("span", { className: "flex items-center gap-1.5", children: [i > 0 && _jsx(ChevronRight, { className: "size-3.5 shrink-0 text-muted-foreground/50", "aria-hidden": true }), interactive
                        ? c.to
                            ? _jsx(Link, { to: c.to, className: "text-muted-foreground transition-colors hover:text-foreground", children: c.label })
                            : _jsx("button", { type: "button", onClick: c.onClick, className: "text-muted-foreground transition-colors hover:text-foreground", children: c.label })
                        : _jsx("span", { className: last ? 'font-medium text-foreground' : 'text-muted-foreground', "aria-current": last ? 'page' : undefined, children: c.label })] }, i));
        }) }));
}
